import HubSpotForm from '@components/hubspot/HubSpotForm';
import { ContentBlock } from '@layouts/ContentBlocks';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import useBreakpoints from '@ui/hooks/useBreakpoints';
import { makeSeoData } from 'config/next-seo.config';
import Head from 'next/head';
import Image from 'next/image';
import { NextSeo } from 'next-seo';
import React from 'react';

import useStyles from './homebuyer.style';

const title = 'Get one-on-one interior design help ';
const description = 'Need support finding the right furniture and decor? We\'re here to help. Share a few details about your space and our team will be in touch.';

export default function HomeBuyer() {
  const { classes, theme } = useStyles();
  const { md } = useBreakpoints();
  
  return (
    <>    
      <Head>
        <title>
          {title}
        </title>
      </Head>

      <NextSeo {...makeSeoData({ pageTitle: title, metaTitle:title, metaDescription: description })} />

      <ContentBlock
        maxWidth={1365}
      >
        <Grid
          container
          justifyContent="space-between"
          spacing={10}
        >
          <Grid
            item
            xs={12}
            md={6}
            style={{
              paddingTop: md ? 80 : 0
            }}
          >
            <Typography
              variant="h1"
              className={classes.heading}
            >
              {title}
            </Typography>

            <Typography className={classes.text}>
              {description}
            </Typography>

            <HubSpotForm
              portalId= "8563089"
              formId= "f278cdde-6b2b-4b4f-a031-66af4703d282"
            />
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            className={classes.rightColumn}
          >
            <div
              style={{
                borderRadius: theme.shape.borderRadius,
                overflow: 'hidden',
                position: 'relative',
                height: md ? 660 : 600,
                width: md ? 520 : '100%',
              }}
            >
              <Image
                fill
                alt=""
                src="/images/home-buyer.png"
                className={classes.image}
                sizes="100vw"
              />
            </div>
          </Grid>
        </Grid>
      </ContentBlock>
    </>
  );
}
